import api from '@/api/axios';
import { ENDPOINTS } from '@/api/endpoints';

/* ========================
 * Safe GET helper
 * ======================== */

export const safeGet = async (endpoint) => {
  try {
    const res = await api.get(endpoint);
    return res.data;
  } catch (error) {
    console.error('[API ERROR]', endpoint, error);
    throw error;
  }
};
export const safePost = async (endpoint, body = {}) => {
  try {
    const res = await api.post(endpoint, body); // pastikan body dikirim
    return res.data;
  } catch (error) {
    console.error('[API ERROR]', endpoint, error.response?.data || error);
    throw error;
  }
};

/**
 * Central API Service
 * Semua request API ada di sini
 */
export const ApiService = {
  getCookieConsent() {
    return safeGet(ENDPOINTS.COOKIE_CONSENT);
  },
  postCookieConsent(payload) {
    return safePost(ENDPOINTS.COOKIE_CONSENT, payload);
  },
  // ================== HOME PAGE ===================
  getHomePage() {
    return safeGet(ENDPOINTS.HOME_PAGE);
  },
  /* ========== ABOUT ========== */
  getAboutPages() {
    return safeGet(ENDPOINTS.ABOUT_PAGES);
  },

  getAboutPageBySlug(slug) {
    return safeGet(ENDPOINTS.ABOUT_PAGE_BY_SLUG(slug));
  },

  /* ========== BANNER SLIDER ========== */
  getBannerSlider() {
    return safeGet(ENDPOINTS.BANNER_SLIDER);
  },

  /* ========== STATISTICS ========== */
  getStatistics() {
    return safeGet(ENDPOINTS.STATISTICS);
  },

  /* ========== KENAL LEBIH DEKAT ========== */
  getKenalLebihDekat() {
    return safeGet(ENDPOINTS.HERO_SECTION);
  },

  /* ========== PRODUK & LAYANAN ========== */
  getServices() {
    return safeGet(ENDPOINTS.SERVICES);
  },
  getServicesList() {
    return safeGet(ENDPOINTS.SERVICES_LIST);
  },

  getServiceBySlug(slug) {
    return safeGet(ENDPOINTS.SERVICE_BY_SLUG(slug));
  },

  getServiceItem(serviceSlug, itemSlug) {
    return safeGet(ENDPOINTS.SERVICE_ITEM(serviceSlug, itemSlug));
  },
  /* ========== VIDEO PRODUCTS ========== */
  getVideoProducts() {
    return safeGet(ENDPOINTS.VIDEO_PRODUCTS);
  },

  /* ========== TESTIMONIALS ========== */
  getTestimonials() {
    return safeGet(ENDPOINTS.TESTIMONIALS);
  },

  /* ========== BERITA ========== */
  getNewsCategories() {
    return safeGet(ENDPOINTS.KATEGORI_BERITA);
  },

  getAllNews: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return safeGet(`${ENDPOINTS.LIST_BERITA}?${query}`);
  },
  getNewsBySlug(slug) {
    return safeGet(ENDPOINTS.BERITA_BY_SLUG(slug));
  },

  getPopularNews() {
    return safeGet(ENDPOINTS.LIST_BERITA_POPULER);
  },

  getRecentNews() {
    return safeGet(ENDPOINTS.LIST_BERITA_TERBARU);
  },

  /* ========== MITRA ========== */
  getPartners() {
    return safeGet(ENDPOINTS.PARTNERS);
  },

  /* ========== ALAMAT KANTOR ========== */
  getOfficeLocations() {
    return safeGet(ENDPOINTS.ALAMAT_KANTOR);
  },

  /* ========== LOKER ========== */
  getJobVacancies() {
    return safeGet(ENDPOINTS.LOKER);
  },
};
